import { SHOW_DEFAULT_HOME_PAGE_BOT, HIDE_ASSISTATNT_BOT, HIDE_CHATWIDGET, OPEN_ASSISTATNT_BOT, SHOW_CHATWIDGET, HIDE_DEFAULT_HOME_PAGE_BOT, SET_INITIALIZE_DEFAULT_HOMEPAGE_BOT, SET_CLEAR_CACHE_FOR_SPINNET_BOT } from "../constants";

const initialState = {
    isAssistantBotOpen: false,
    isOpenChatWidget: false,
    isDefaultHomePageBot: false,
    clearCacheForSpinnetBot : false,
    initializeDefaultHomePage: false //to navigate to DefaultHomePage only for first time when user login
};


const botReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_ASSISTATNT_BOT:
            return {
                ...state,
                isAssistantBotOpen: true,
                isOpenChatWidget: false,
                isDefaultHomePageBot: false
            };

        case HIDE_ASSISTATNT_BOT:
            return {
                ...state,
                isAssistantBotOpen: false,
                isOpenChatWidget: false
            };

        case SHOW_CHATWIDGET:
            return {
                ...state,
                isOpenChatWidget: true,
                isAssistantBotOpen: false,
            };

        case HIDE_CHATWIDGET:
            return {
                ...state,
                isOpenChatWidget: false,
                isAssistantBotOpen: false,
            }

        case SHOW_DEFAULT_HOME_PAGE_BOT:
            return {
                ...state,
                isOpenChatWidget: false,
                isAssistantBotOpen: false,
                isDefaultHomePageBot: true,
            };

        case HIDE_DEFAULT_HOME_PAGE_BOT:
            return {
                ...state,
                isOpenChatWidget: false,
                isAssistantBotOpen: false,
                isDefaultHomePageBot: false,
            };
            
        case SET_INITIALIZE_DEFAULT_HOMEPAGE_BOT:
            return {
                ...state,
                initializeDefaultHomePage: true,
            };

        case SET_CLEAR_CACHE_FOR_SPINNET_BOT:
            return {
                ...state,
                clearCacheForSpinnetBot: action.payload,
            };

        default:
            return state;
    };
};

export default botReducer;
